<template>
  <div class="h-screen flex px-3 overflow-scroll">
    <slot></slot>
  </div>
</template>
